import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { AccountData } from "@markit/common.types";
import { Colors } from "../../utils/colors";
import { DataLoaders } from "../../redux/slices/dataSlice";
import { useNavigate } from "../../hooks/useNavigate";
import { onProfilePageNavigatePath } from "../../utils/navigationUtils";
import { useTheme } from "../../hooks/useTheme";
import ProfilePic from "../ProfilePic";

const FeaturedPeopleCard = (props: { person: AccountData }) => {
  const { person } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const [onHover, setOnHover] = useState(false);

  const styles = {
    subtext: {
      fontSize: 14,
      color: Colors.GRAY1,
    },

    card: {
      gap: 7,
      padding: 14,
      borderRadius: 20,
      border: `1.5px solid ${theme.DividerColor.borderColor}`,
      backgroundColor: onHover ? Colors.GRAY6 : Colors.WHITE1,
      transition: "background-color 0.3s ease",
    },

    button: {
      backgroundColor: Colors.BLACK,
      color: Colors.WHITE,
      borderRadius: 8,
      padding: 10,
      width: 79,
      fontSize: 12,
      fontWeight: 600,
      border: "none",
      cursor: "pointer",
      transition: "opacity 0.2s ease",
    },
  };

  const navigateToUser = useCallback(
    (showForm?: boolean) => {
      dispatch(DataLoaders.user(person.uid));
      onProfilePageNavigatePath(
        navigate,
        person.username,
        showForm ? "subscribe" : undefined
      );
    },
    [dispatch, navigate, person.uid, person.username]
  );

  return (
    <div
      style={styles.card}
      className="AlignedRowSpacedSelect"
      key={person.uid}
      onClick={() => navigateToUser()}
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
    >
      <div className="ColumnNormal" style={{ gap: 14 }}>
        <div className="ColumnNormal" style={{ gap: 7, width: 220 }}>
          <span
            style={{ fontSize: 20, fontWeight: 500 }}
            className="TextOverflowEllipsis"
          >
            {person.fullName}
          </span>
          <span className="bodySubtext">@{person.username}</span>
        </div>
        <button
          style={styles.button}
          onClick={(e) => {
            e.stopPropagation();
            navigateToUser(true);
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >
          Subscribe
        </button>
      </div>
      <ProfilePic
        user={person}
        size={100}
        borderStyle={`0.5px solid ${Colors.GRAY2}`}
        forcePointer
      />
    </div>
  );
};

export default FeaturedPeopleCard;
